import {Drawer, IconButton} from "@mui/material";
import ArrowDropDownCircleIcon from "@mui/icons-material/ArrowDropDownCircle";
import MenuIcon from "@mui/icons-material/Menu";
import {AppSpecificToolbar} from "./AppSpecificToolbar";
import {AppNavToolbar} from "./AppNavToolbar";
import React, {FC} from "react";
import {useSelector} from "react-redux";
import {AppState} from "../../AppState";
import {SystemActions} from "../../actions/SystemActions";
import UserAvatar from "../profile/UserAvatar";
import {SpecialFolderList} from "../folder/SpecialFolderList";
import {SidebarView} from "../folder/SidebarView";
import {useAppDispatch, useAppSelector} from "../../hooks/ReduxHooks";
import {isEmailContent} from "../../domain/ItemContent";
import {EmailToolbar} from "./EmailToolbar";
import {AttachmentFolderId, PhotosFolderId, ProtectedFilesFolderId} from "../../reducers/FolderReducer";
import {getItemContent} from "../../state/ItemState";

export const MobileToolbar: FC = () => {

    const showFolderMenu = useAppSelector(s => s.system.showFolderMenu || (s.folderState.selectedFolder === undefined && s.folderState.selectedFolderId !== -1));
    const showToolbarMenu = useAppSelector(({system}: AppState) => system.showToolbarMenu);

    const hasServerError = useAppSelector(({system}: AppState) => system.systemMessages.length > 0);

    const dispatch = useAppDispatch();

    const onShowFolderMenu = (show: boolean) => dispatch(SystemActions.showFolderMenu(show));
    const onShowToolbarMenu = (show: boolean, e?: any) => {
        dispatch(SystemActions.showToolbarMenu(show));
        e?.stopPropagation();
    };

    const folderMenuAvailable = useAppSelector(s => s.system.appConfig.showFolderMenuFn(s));

    const showAppControlsInToolbar = useAppSelector(s => s.system.appConfig.showAppControlsInMobileToolbar);

    const mobileSelectionEnabled = useAppSelector(s => s.itemState.mobileSelectionEnabled);
    const showMobileSearch = useSelector(({system}: AppState) => system.appConfig.showMobileSearch);
    const hasContent = useAppSelector(s => isEmailContent(getItemContent(s.itemState))
        && s.folderState.selectedFolderId !== ProtectedFilesFolderId
        && s.folderState.selectedFolderId !== AttachmentFolderId
        && s.folderState.selectedFolderId !== PhotosFolderId);

    const showEmailMenu = hasContent || mobileSelectionEnabled;

    return (
        <>
            {folderMenuAvailable &&
                <IconButton className="flip"
                            onClick={() => onShowFolderMenu(!showFolderMenu)}><ArrowDropDownCircleIcon/></IconButton>}

            {showMobileSearch && !showEmailMenu && <SpecialFolderList/>}
            {showMobileSearch && showEmailMenu && <EmailToolbar reducedMenu/>}

            <IconButton color="primary"
                        onClick={e => onShowToolbarMenu(!showToolbarMenu, e)}
                        className="email-toolbar-menu">
                <MenuIcon color={hasServerError ? "secondary" : "action"}/>
            </IconButton>

            {folderMenuAvailable &&
                <Drawer open={showFolderMenu} onClose={() => onShowFolderMenu(false)} transitionDuration={100} keepMounted>
                    <SidebarView/>
                </Drawer>}

            {showAppControlsInToolbar && <AppSpecificToolbar/>}

            <Drawer open={showToolbarMenu} onClose={() => onShowToolbarMenu(false)} anchor="right" keepMounted
                    transitionDuration={100}>
                <div className="main-toolbar main-toolbar-vertical">
                    {!showAppControlsInToolbar && <AppSpecificToolbar/>}
                    <AppNavToolbar/>
                    <UserAvatar/>
                </div>
            </Drawer>
        </>);
}
